// Service pour interagir avec l'API Giphy
// Clé API Giphy (à configurer dans les variables d'environnement)
// Pour obtenir une clé gratuite, visitez: https://developers.giphy.com/
const GIPHY_API_KEY = process.env.REACT_APP_GIPHY_API_KEY || '99M7dqxqCK1E2d0Mce7WwAnT07Ig72lJ';
const GIPHY_BASE_URL = 'https://api.giphy.com/v1/gifs';

export const giphyService = {
  /**
   * Rechercher des GIFs sur Giphy
   * @param {string} query - Terme de recherche
   * @param {number} limit - Nombre de résultats (max 50)
   * @param {number} offset - Décalage pour la pagination
   * @returns {Promise<Object>} - Résultats de recherche
   */
  searchGifs: async (query, limit = 20, offset = 0) => {
    try {
      const response = await fetch(
        `${GIPHY_BASE_URL}/search?api_key=${GIPHY_API_KEY}&q=${encodeURIComponent(query)}&limit=${limit}&offset=${offset}&rating=g&lang=fr`
      );

      if (!response.ok) {
        throw new Error(`Erreur Giphy: ${response.status}`);
      }

      const data = await response.json();
      return {
        gifs: data.data.map(gif => ({
          id: gif.id,
          title: gif.title,
          url: gif.images.original.url,
          preview: gif.images.fixed_height.url,
          width: gif.images.original.width,
          height: gif.images.original.height,
          size: gif.images.original.size,
        })),
        pagination: data.pagination,
      };
    } catch (error) {
      console.error('Erreur lors de la recherche Giphy:', error);
      throw error;
    }
  },

  /**
   * Obtenir les GIFs tendances
   * @param {number} limit - Nombre de résultats (max 50)
   * @param {number} offset - Décalage pour la pagination
   * @returns {Promise<Object>} - GIFs tendances
   */
  getTrendingGifs: async (limit = 20, offset = 0) => {
    try {
      const response = await fetch(
        `${GIPHY_BASE_URL}/trending?api_key=${GIPHY_API_KEY}&limit=${limit}&offset=${offset}&rating=g`
      );

      if (!response.ok) {
        throw new Error(`Erreur Giphy: ${response.status}`);
      }

      const data = await response.json();
      return {
        gifs: data.data.map(gif => ({
          id: gif.id,
          title: gif.title,
          url: gif.images.original.url,
          preview: gif.images.fixed_height.url,
          width: gif.images.original.width,
          height: gif.images.original.height,
          size: gif.images.original.size,
        })),
        pagination: data.pagination,
      };
    } catch (error) {
      console.error('Erreur lors de la récupération des GIFs tendances:', error);
      throw error;
    }
  },

  /**
   * Obtenir un GIF par ID
   * @param {string} id - ID du GIF Giphy
   * @returns {Promise<Object>} - Détails du GIF
   */
  getGifById: async (id) => {
    try {
      const response = await fetch(
        `${GIPHY_BASE_URL}/${id}?api_key=${GIPHY_API_KEY}`
      );

      if (!response.ok) {
        throw new Error(`Erreur Giphy: ${response.status}`);
      }

      const data = await response.json();
      const gif = data.data;
      return {
        id: gif.id,
        title: gif.title,
        url: gif.images.original.url,
        preview: gif.images.fixed_height.url,
        width: gif.images.original.width,
        height: gif.images.original.height,
        size: gif.images.original.size,
      };
    } catch (error) {
      console.error('Erreur lors de la récupération du GIF:', error);
      throw error;
    }
  },

  /**
   * Vérifier si la clé API est configurée
   * @returns {boolean}
   */
  isConfigured: () => {
    return GIPHY_API_KEY && GIPHY_API_KEY !== 'YOUR_GIPHY_API_KEY';
  },
};

